import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NBankcardPriceTrendApi = global.NBankcardPriceTrendApi

class BankPriceTrend extends Http {
  [x: string]: any

  /**
   * 银行价格接口-区分角色
   * @param data
   * @returns
   */
  public async getSupplementBankCardPrice(data: NBankcardPriceTrendApi.BankcardPriceTrendRequest) {
    return await super.request<NBankcardPriceTrendApi.BankcardPriceTrendResponse>({
      url: '/crossbowSystem/supplementBankCardPrice',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  /**
   * 银行价格接口-不区分角色
   * @param data
   * @returns
   */
  public async getComprehensiveBankCardPrice(data: NBankcardPriceTrendApi.BankcardPriceTrendRequest) {
    return await super.request<NBankcardPriceTrendApi.BankcardPriceTrendResponse>({
      url: '/crossbowSystem/comprehensiveBankCardPrice',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default BankPriceTrend
